// @flow

import {
  OPEN_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL,
  CLOSE_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL,
  DELETE_SEARCH_NOTIFICATION_REQUEST,
  DELETE_SEARCH_NOTIFICATION_SUCCESS,
  DELETE_SEARCH_NOTIFICATION_ERROR,
} from './actionTypes';
import type { SearchNotification } from '../SearchNotifications/types';
import type {
  OpenSearchNotificationConfirmDeleteModalAction,
  CloseSearchNotificationConfirmDeleteModalAction,
  ConfirmDeleteSearchNotificationAction,
  DeleteSearchNotificationSuccessAction,
  DeleteSearchNotificationErrorAction,
} from './types';

export function openSearchNotificationConfirmDeleteModal(
  searchNotification: SearchNotification<*>
): OpenSearchNotificationConfirmDeleteModalAction {
  return {
    type: OPEN_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL,
    payload: {
      searchNotification,
    },
  };
}

export function closeSearchNotificationConfirmDeleteModal(): CloseSearchNotificationConfirmDeleteModalAction {
  return {
    type: CLOSE_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL,
  };
}

export function confirmDeleteSearchNotification(): ConfirmDeleteSearchNotificationAction {
  return {
    type: DELETE_SEARCH_NOTIFICATION_REQUEST,
  };
}

export function deleteSearchNotificationSuccess(
  searchNotification: SearchNotification<*>
): DeleteSearchNotificationSuccessAction {
  return {
    type: DELETE_SEARCH_NOTIFICATION_SUCCESS,
    payload: {
      searchNotification,
    },
  };
}

export function deleteSearchNotificationError(
  previousSearchNotifications: SearchNotification<*>[]
): DeleteSearchNotificationErrorAction {
  return {
    type: DELETE_SEARCH_NOTIFICATION_ERROR,
    payload: {
      searchNotifications: previousSearchNotifications,
    },
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/DeleteSearchNotification/actions.js